<template>
  <!--  Top menu -->
  <nav
    id="mainNav"
    class="navbar navbar-expand-md navbar-dark fixed-top"
  >
    <div class="container-fluid">
      <router-link
        @click.native="scrollToTop"
        class="navbar-brand"
        style="width:100%"
        to="/home"
        routerLinkActive="active-link"
      >
        <img
          id="image"
          src="/static/img/logo_date.png"
          class="img-fluid"
          width="110"
          height="37"
        />
      </router-link>
    </div>
  </nav>
</template>
<script>
export default {
  data() {
    return {
      searchactive: false,
      isScrolling: false,
    };
  },
  mounted() {
    this.onScrollEvent();
  },
  methods: {
    showSearch() {
      this.searchactive = !this.searchactive;
    },
    scrollToTop() {
    window.scrollTo({top: 0, behavior: 'smooth'});
           },
    menuToggleLink(id) {
      if (document.getElementById(id).classList.contains("open")) {
        document.getElementById(id).classList.remove("open");
      } else if (!document.getElementById(id).classList.contains("open")) {
        let elements = document.querySelectorAll(".parent");
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.remove("open");
        }
        document.getElementById(id).classList.add("open");
      }
    },
    addToggleClass() {
      document.querySelector("body").classList.toggle("rtl-enable");
    },
    removeCollapseInClass() {
      document.getElementById("navbarCollapse").classList.remove("show");
    },
    onScrollEvent() {
      var that = this;
      var headerSticky = document.getElementById("image");
      window.onscroll = function() {
        if (window.pageYOffset >= 100) {
          that.isScrolling = true;
          headerSticky.classList.add("scrollHeaderMove");
        } else {
          that.isScrolling = false;
          headerSticky.classList.remove("scrollHeaderMove");
        }
      };
    }
  }
};
</script>
<style scoped>
.scrollHeader {
  /* background-color: #1565c0; */
  background-color: transparent;
}

.scrollHeaderMove {
  opacity: 0.2;
  width: 8% !important;
  height: auto !important;
  top: 10px !important;
  left: 10px !important;
  position: absolute;
}

#image {
  -webkit-transition: all 1s ease-in-out;
  -moz-transition: all 1s ease-in-out;
  -ms-transition: all 1s ease-in-out;
  -o-transition: all 1s ease-in-out;
  transition: all 1s ease-in-out;
  left: 59vw;
  top: 19vh;
  width: 18%;
  height: auto;
  position: absolute;
}

/*iPad Pro */
@media screen and (max-width: 1024px) and (orientation: portrait) {
  #image {
    -webkit-transition: all 1s ease-in-out;
    -moz-transition: all 1s ease-in-out;
    -ms-transition: all 1s ease-in-out;
    -o-transition: all 1s ease-in-out;
    transition: all 1s ease-in-out;
    left: 60vw;
    top: 20vh;
    width: 35%;
    height: auto;
    position: absolute;
  }
}


/*mobile */
@media screen and (max-width: 500px) {
  #image {
    -webkit-transition: all 1s ease-in-out;
    -moz-transition: all 1s ease-in-out;
    -ms-transition: all 1s ease-in-out;
    -o-transition: all 1s ease-in-out;
    transition: all 1s ease-in-out;
    left: 55vw;
    top: 30vh;
    width: 40%;
    height: auto;
    position: absolute;
  }
}
</style>
